import { render, staticRenderFns } from "./MobileNavigationWrapper.vue?vue&type=template&id=5ed976f4&"
import script from "./MobileNavigationWrapper.vue?vue&type=script&lang=js&"
export * from "./MobileNavigationWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports